import React, { FC } from "react";
import { Button, Table, Input, Upload, Tooltip } from "antd";
import { YhBox } from "@/components/YhBox";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { globalPrompt } from "@/components/message";
import { ColumnsType } from "antd/es/table";
import { DetailType } from "@/types/ScmEnums";
import { useStockCheckDetailModel, IMaterialDetailModel } from "./stockCheckDetailsModel";
import { IMaterialBase, IMaterialDetail, IMaterialSearchFields, materialService } from "../../../../base/material/materialService"
import { IStockCheckFields, IDetailList, IStockCheckDetail, IStockCheckSearch, Detailed } from "../../stockCheckType"
import { EditableCell, EditableRow } from "@/components/YHEditTable/editTable";
import { importPropsConfig } from "@/utils/importFile";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
import useGlobalModel from "@/model/globalModel";
import { useDictModel } from "@/views/base/dict/dictModel";
import { bigNumber, formatIntPoint, formatNum } from "@/utils/utils";


export const TableBox: FC<RouterParamType> = ({ id, mode }) => {
    const { setAddModalVisible, detailDataSource, detaiAddDataRowKeys,onExport,modelScreenMethod, setProfitAndLoss, detailLookList, detailAddList, detailDataRowKeys, detailDataRow, setDetailAddList, setDetailDataRow, setDetailDataSource, setDetailDataRowKeys, detailDetailList, setDetaiAddDataRowKeys, setDetaiAddDataRow } = useStockCheckDetailModel();
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { language,setLocale, warehouseList } = useGlobalModel()
    const Locale = setLocale(LanguageArr)
    const { getTreeNodeOne } = useDictModel();


    const importCallback = async (list: any) => {
        console.log(list)
        let newList = list.map((item: any) => {
            return {
                ...item,

            }
        })
        if (mode == "add") {
            const { repetition, newDetailData } = await modelScreenMethod(list, detailAddList)
            setDetailAddList([...detailAddList, ...newDetailData])
            repetition.length != 0 && globalPrompt("message", { text: `物料名称：${repetition.join(",")}，重复的将不在添加。`, type: "warning" });
        } else if (mode == "edit") {
            const { repetition, newDetailData } = await modelScreenMethod(list, detailDataSource)
            setDetailDataSource([...detailDataSource, ...newDetailData])
            repetition.length != 0 && globalPrompt("message", { text: `物料名称：${repetition.join(",")}，重复的将不在添加。`, type: "warning" });
        }
    }
    const action = mode == DetailType.look ? <></> : <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => setAddModalVisible(true)}
        >{Locale["Add Material"]}</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => { detailDetailList(mode) }}
        >{Locale["Delete Material"]}</Button>
        {/* <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => { console.log("导入明细") }}
        >导入明细</Button> */}
        <Upload showUploadList={false} className="mr-10 ml-10" {...importPropsConfig(`/vrm-sa/stock/check/details/import`, importCallback)}>
            <Button className="mr-5" type="link" shape="round">{Locale["Import Details"]}</Button>
        </Upload>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => { onExport() }}
        >{Locale["Download template"]}</Button>
    </>;
    let Result:any = {
        "盘盈":Locale["Surplus"],
        "盘亏":Locale["Loss"],
        "相符":Locale["Equal"],
    }
    const columns = [
        {
            // title: '序号',
            title: Locale["SN"],
            width: 80,
            render: (t: string, r: any, i: number) => <>{i + 1}</>
        }, {
            // title: '商品编码',
            title: Locale["Material Code"],
            width: 180,
            dataIndex: 'materialCode',
            render: (text:any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            // title: '商品名称',
            title: Locale["Material Name"],
            dataIndex: 'materialName',
            render: (text:any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            // title: '商品名称-英文',
            title: Locale['Material Name En'],
            width: 160,
            dataIndex: 'nameEn',     
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>, 
        // }, {
        //     title: '单位',
        //     dataIndex: 'unitName',
        // }, {
        //     title: '规格型号',
        //     width: 180,
        //     dataIndex: 'model',
        //     render: (text:any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            // title: '商品品牌',
            title: Locale["Material Brand"],
            dataIndex: 'brandCode',
            render: (text: any) => {
                if (text) {
                    return language == "zh-CN" ? getTreeNodeOne(text)[0].name : getTreeNodeOne(text)[0].nameEn as string
                } else {
                    return ""
                }
            }
        }, {
            // title: '仓库',
            title: Locale["Warehouse"],
            dataIndex: 'warehouseName',
        }, {
            // title: '货位',
            title: Locale["Shelf"],
            dataIndex: 'shelfCode',
        }, {
            // title: '库存数量',
            title: Locale["Qty in Stock"],
            dataIndex: 'inventoryNum',
        }, {
            // title: '盘点数量',
            title: Locale["Stocktaking Num"],
            dataIndex: 'realNum',
            editable: mode != "look" ? true : false,
        }, {
            // title: '单价',
            title: Locale["Unit Price"],
            dataIndex: 'averagePurchasePrice',
        },{
            // title: '盘点结果',
            title: Locale["Result"],
            dataIndex: 'result',
            render:(text:any)=>Result[text]
        }, {
            // title: '差异量',
            title: Locale["Difference Qty"],
            dataIndex: 'differenceNum',
        }, {
            // title: <span style={{ color: "red" }}>差异金额</span>,
            title: <span style={{ color: "red" }}>{Locale["Difference Amount"]}</span>,
            dataIndex: 'differenceAmount',
        }
        // , {
        //     title: '备注',
        //     dataIndex: 'note',
        // }
    ];
    const newSelectMaterialColums = () =>
        columns.map((col: any, index) => {
            return {
                ...col,
                onCell: (record: IDetailList, rowIndex: number) => ({
                    colIndex: index + 1,
                    rowIndex,
                    record,
                    rules: col.rules,
                    options: col.options,
                    editType: col.editType,
                    suffix: col.suffix,
                    editable: col?.editable,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    handleSave: handleMaterialSave,
                }),
            }
        })
    const handleMaterialSave = (row: IDetailList) => {
        let { realNum, result, differenceAmount, differenceNum, inventoryNum, latestPurPrice, averagePurchasePrice } = row
        // realNum=+formatNum(realNum);
        const reg = /([0-9]+\.[0-9]{1})[0-9]*/;
        realNum=+formatNum(String(realNum).replace(reg,'$1'))
        differenceNum=+formatNum(String(bigNumber.minus(realNum as number,inventoryNum as number)).replace(reg,'$1'))
        let newRow = {
            ...row,
            realNum,
            differenceNum,
            result: setProfitAndLoss(Number(realNum) - Number(inventoryNum)),
            differenceAmount: +((Number(realNum) - Number(inventoryNum)) * Number(averagePurchasePrice)).toFixed(2)
        }
        let newData = mode == "edit" ? detailDataSource : detailAddList;
        const index = newData.findIndex((item) => row.detailsId === item.detailsId);
        const item = newData[index];
        newData.splice(index, 1, { ...item, ...newRow });
        mode == "edit" ? setDetailDataSource([...newData]) : setDetailAddList([...newData])
    }
    const typeList = {
        "add": detailAddList,
        "edit": detailDataSource,
        "look": detailLookList,

    }
    const setTypeDetailDataRowKeysAndRow = async (selectedRowKeys: React.Key[], mode: string) => {
        if (mode == DetailType.add) {
            setDetaiAddDataRowKeys(selectedRowKeys)
        } else if (mode == DetailType.edit) {
            setDetailDataRowKeys(selectedRowKeys)
        }
    }
    const setTypeDetailDataRow = async (selectedRows: IDetailList[], mode: string) => {
        if (mode == DetailType.add) {
            setDetaiAddDataRow(selectedRows)
        } else if (mode == DetailType.edit) {
            setDetailDataRow(selectedRows)
        }
    }
    return (
        <YhBox title={Locale["Stocktaking Details"]} rightChildren={action} style={{ marginBottom: "75px" }}>
            <Table
                rowKey={record => record.detailsId as string}
                rowSelection={
                    mode == DetailType.look ? undefined : {
                        selectedRowKeys: mode == DetailType.add ? detaiAddDataRowKeys : detailDataRowKeys, //记录选中
                        onChange: (selectedRowKeys: React.Key[], selectedRows: IDetailList[]) => {
                            setTypeDetailDataRowKeysAndRow(selectedRowKeys, mode)
                            setTypeDetailDataRow(selectedRows, mode)
                        },
                        onSelectAll: (selected, selectedRows, changeRows) => {
                            setTypeDetailDataRow(selectedRows, mode)
                        }
                    }}
                columns={newSelectMaterialColums() as ColumnsType<IDetailList>}
                dataSource={typeList[mode]}
                pagination={false}
                onRow={record => ({
                    onClick: () => { }
                })}
                components={{
                    body: {
                        row: EditableRow,
                        cell: EditableCell,
                    },
                }}
                scroll={{ x: 'max-content', y: 290 }}
            />
        </YhBox>
    )
}